var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSecurityUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.74166 1.8583L4.58334 3.41663C3.62501 3.77496 2.84167 4.90829 2.84167 5.93329V12.1249C2.84167 13.1083 3.49168 14.4 4.28335 14.9916L7.86667 17.6666C9.04167 18.55 10.975 18.55 12.15 17.6666L15.7333 14.9916C16.525 14.4 17.175 13.1083 17.175 12.1249V5.93329C17.175 4.90829 16.3917 3.77496 15.4333 3.41663L11.275 1.8583C10.5667 1.59997 9.43333 1.59997 8.74166 1.8583Z",
    stroke: "#8490A5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 9.1001C9.96668 9.1001 9.92501 9.1001 9.89167 9.1001C9.10834 9.0751 8.48334 8.42509 8.48334 7.63342C8.48334 6.82509 9.14168 6.16675 9.95001 6.16675C10.7583 6.16675 11.4167 6.82509 11.4167 7.63342C11.4084 8.43342 10.7833 9.0751 10 9.1001Z",
    stroke: "#8490A5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.3417 11.4335C7.5417 11.9669 7.5417 12.8419 8.3417 13.3752C9.25003 13.9835 10.7417 13.9835 11.65 13.3752C12.45 12.8419 12.45 11.9669 11.65 11.4335C10.75 10.8252 9.25837 10.8252 8.3417 11.4335Z",
    stroke: "#8490A5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityUser);
export default __webpack_public_path__ + "static/media/security-user.54ff9345648297b81fa9e6c10935feae.svg";
export { ForwardRef as ReactComponent };